// extracted by mini-css-extract-plugin
export default {"switchView3d":"SwitchView3d_switchView3d__VRjnA"};